import { useGetProcedures } from '@vindr/services/actions/procedure.api';
import { MESSAGE } from '@vindr/services/constants/message.constant';
import { useDebounce } from '@vindr/utils/hooks/useDebounce';
import { Select } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FormItemProps } from '../templates/FormProps';
import FormSelect from '../templates/FormSelect';

interface ProcedureGroup extends FormItemProps {
  editItem?: Record<string, any>;
  onChange?: (value: any) => void;
  institutionId?: string;
}

const ProcedureList = ({
  name = 'procedure_id',
  label = 'Procedure Name',
  placeholder = 'Select Procedure Name',
  multiple = false,
  onChange,
  rules,
  required = false,
  disabled,
  institutionId,
  ...props
}: ProcedureGroup) => {
  const { t } = useTranslation('Vindoc');
  const [searchTerm, handleSearch] = useDebounce<string>();
  const { data, isInitialLoading, isRefetching } = useGetProcedures({
    limit: 100,
    offset: 0,
    active: true,
    institution_ids: [institutionId],
    ...(searchTerm && { name: searchTerm }),
  });

  const layoutList = data?.data;

  const rulesMemo = useMemo(() => {
    const rulesState = [];
    if (required)
      rulesState.push({ required: true, message: t(MESSAGE.INLINE.IEM_0001) });
    if (rules) rulesState.push(...rules);

    return rulesState;
  }, [t, required, rules]);

  return (
    <FormSelect
      {...{ name, label, placeholder, disabled, ...props }}
      {...(multiple && { mode: 'multiple' })}
      loading={isInitialLoading || isRefetching}
      {...(rules || (required && { rules: rulesMemo }))}
      onChange={onChange}
      onSearch={handleSearch}
      showSearch
    >
      {layoutList?.map((procedure) => (
        <Select.Option key={procedure.id} value={procedure.id}>
          {procedure.name}
        </Select.Option>
      ))}
    </FormSelect>
  );
};

export default ProcedureList;
